// https://stackoverflow.com/questions/1353684/detecting-an-invalid-date-date-instance-in-javascript
export function isValidJsDate(maybeDate: any): boolean {
  return maybeDate instanceof Date && !Number.isNaN(maybeDate);
}

